<template>
	<div class="ss-content cultura-info-content">
		<div class="ss-container">
			<div class="ss-container__left_small">
				<ul class="cultura-info-types">
					<li style="background-color: #0460FE;color: #fff;">圈子分类</li>
					<li v-for="(item, index) in typeList" :class="{active: typeIndex === index}" @click="changeType(index)" :key="item.value">{{item.label}}</li>
				</ul>
			</div>
			<div class="ss-container__middle">
				<div class="search-content" v-if="circleEnabled">
					<button class="fr btn-primary" @click="publishFn">
						<img src="~@/assets/img/culturalCircles/edit.png" />
						发表内容
					</button>
					<div class="search-box">
						<input class="search-box__input" v-model="searchTitle" @keyup.enter="changeType(typeIndex)" placeholder="请输入搜索内容" />
						<img src="~@/assets/img/main/search.png" @click="changeType(typeIndex)" />
					</div>
				</div>
				<div class="circles-box">
					<ss-circles-list :value="curData_" :finish="finish_" :busy="busy_" :searchContent="searchTitle" />
				</div>
				<div class="page-more" v-if="!busy_">
					<span @click="changeType(typeIndex, curPage + 1)">点击加载更多圈子内容</span>
				</div>
			</div>
			<div class="ss-container__right">
				<ssUserInfoRight />
			</div>
		</div>
		<ss-modal v-model="publishFlag">
			<div class="publish-box">
				<p class="publish-title">发表圈子</p>
				<div class="publish-content">
					<div class="clearfix publish-select-box">
						<div class="fl">所属圈子</div>
						<div class="fl">
							<select v-model="channelId">
								<option v-for="item in typeList_" :value="item.value" :key="item.value">{{item.label}}</option>
							</select>
						</div>
					</div>
					<!-- <VueEmoji class="publish-textarea" @input="onInput" :value="myText" /> -->
					<textarea class="publish-textarea" v-model="content"></textarea>
					<ss-upload maxCount="9" @change="uploadSuccess" @add="uploadAdd"></ss-upload>
					<div class="publish-btn-group">
						<button class="btn-primary-hollow btn-sm" @click="publishFlag = false">取消</button>
						<button class="btn-primary btn-sm" @click="culturalIssue">发布</button>
					</div>
				</div>
			</div>
		</ss-modal>
	</div>
</template>

<script>
	import ssUpload from '@/components/ss-upload/ss-upload.vue'
	// import VueEmoji from 'emoji-vue'
	import ssCirclesList from '@/components/ss-circles-list/ss-circles-list.vue'
	import ssUserInfoRight from '@/components/ss-user-info-right/ss-user-info-right.vue'
	import listMixin from '@/mixins/list.js'
	import { mapState } from 'vuex'
	export default {
		mixins: [ listMixin ],
		name: 'culturalActivity',
		components:{
			ssCirclesList, 
			ssUpload,
			ssUserInfoRight
			// VueEmoji
		},
		data(){
			return {
				publishFlag: false,
				isConcat: true,
				typeList: [{
					value: '',
					label: '全部'
				}],
				channelId: '',
				content: '',
				multiPicsList: [],
				multiTempPicsList: [],
				defaultImg: [],
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.user.userInfo,
				circleEnabled: state => state.user.userInfo.circleEnabled || false
			}),
			typeList_() {
				let typeList = [...this.typeList];
				typeList.splice(0, 1)
				return typeList;
			}
		},
		created() {
			this.getCulturalClassify();
		},
		methods: {
			publishFn() {
				if(!this.userInfo.username) return this.$toast('请登录后操作');
				this.publishFlag = true;
			},
			async culturalIssue() {
				if(!this.content) return this.$toast('圈子内容不能为空');
				if(this.multiPicsList.length !== this.multiTempPicsList.length) return this.$toast('图片还未上传完成');
				if(!this.channelId) return this.$toast('请选择圈子类型');
				let multiPicsIdList = this.multiPicsList.map(o => o.resourceId);
				let res = await this.$http('culturalIssue', {
					channelId: this.channelId,
					content: this.content,
					multiPicsIdList: multiPicsIdList
				});
				if(res.code === 1){
					this.publishFlag = false;
					this.content = '';
					this.channelId = '';
					this.multiTempPicsList = [];
					this.multiPicsList = [];
				}
			},
			uploadSuccess(e) {
				this.multiPicsList = e;
			},
			uploadAdd(e) {
				this.multiTempPicsList = e;
			},
			async getCulturalClassify() {
				let res = await this.$http('culturalClassify');
				if(res.code === 1){
					res.data.forEach(o => {
						o.label = o.name;
						o.value = o.id;
					})
					this.typeList = this.typeList.concat(res.data);
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.publish-box{
		width: 546px;
		min-height: 500px;
		padding: 30px 60px;
		background-color: #fff;
		.publish-content{
			margin-top: 35px;
			font-size: 18px;
			font-weight: 400;
			color: #484848;
			.publish-btn-group{
				font-size: 0;
				margin-top: 30px;
				text-align: right;
				button{
					display: inline-block;
					width: 126px;
					margin-left: 20px;
					border-radius: 5px;
				}
			}
			.publish-textarea{
				margin-top: 30px;
				height: 163px!important;
			}
			.publish-select-box{
				line-height: 44px;
				select{
					margin-left: 14px;
					display: block;
					width: 253px;
					height: 44px;
					line-height: 42px;
					background: #FFFFFF;
					border: 1px solid #DDDDDD;
					border-radius: 3px;
					padding: 0 10px;
					font-size: 15px;
					font-weight: 400;
					color: #757575;
				}
			}
		}
		.publish-title{
			text-align: center;
			font-size: 24px;
			font-weight: bold;
			color: #484848;
		}
	}
	.cultura-info-content{
		padding-bottom: 70px;
		background:rgba(248,248,248,1);
		.page-more{
			text-align: center;
			span{
				font-size:16px;
				font-weight:400;
				color:rgba(72,72,72,1);
				line-height:30px;
				margin-top: 30px;
				cursor: pointer;
				display: inline-block;
			}
		}
		.circles-box{
		}
		
		.search-content{
			height:52px;
			background:rgba(255,255,255,1);
			border:1px solid rgba(222,222,222,1);
			padding: 7px 20px 8px;
			margin-bottom: 18px;
			.search-box{
				margin-top: 4px;
				position: relative;
				display: inline-block;
				.search-box__input{
					padding: 0 50px 0 13px;
					width:220px;
					height:30px;
					line-height:28px;
					background:rgba(255,255,255,1);
					border:1px solid rgba(222,222,222,1);
					border-radius:15px;
				}
				img{
					cursor: pointer;
					width: 18px;
					display: block;
					@include abs(6px, 14px);
				}
			}
			.fr{
				height:37px;
				line-height:37px;
				border-radius:5px;
				font-size:15px;
				width: 192px;
				img{
					width: 16px;
					height: 16px;
					display: inline-block;
					vertical-align: middle;
				}
			}
		}
		.ss-container__left_small{
			border:1px solid rgba(222,222,222,1);
		}
		.cultura-info-list{
			border-top: 1px solid #DEDEDE;
			li{
				position: relative;
				padding: 10px 0;
			}
			.cultura-info__time{
				font-size:14px;
				font-weight:400;
				color:rgba(185,185,185,1);
				line-height:18px;
				margin-top: 10px;
			}
			.cultura-info__title{
				font-size:20px;
				font-weight:400;
				color:rgba(32,42,48,1);
				line-height:28px;
			}
			.cultura-info__image{
				width:155px;
				display: block;
				float: left;
			}
			.cultura-info__content{
				width: 495px;
				float: right;
				padding: 25px 15px 0 20px;
			}
			.cultura-info__tool{
				display: inline-block;
				font-size:16px;
				font-weight:400;
				color: #666666;
				line-height:18px;
				& + .cultura-info__tool{
					margin-left: 25px;
				}
			}
		}
		.cultura-info-types{
			background-color: #fff;
			padding-bottom: 20px;
			border-top: 4px solid #044AD2;
			li{
				cursor: pointer;
				text-align: center;
				position: relative;
				height:55px;
				line-height:55px;
				font-size:18px;
				font-weight:400;
				color: #484848;
				&:last-child:after, &:first-child:after{
					display: none;
				}
				&::after{
					content: '';
					@include abs(null, 15px, 0, 15px);
					background-color: #DEDEDE;
					height: 1px;
				}
				&.active, &:hover{
					background: #ADCCFF;
					color: #0260FE;
				}
			}
		}
	}
</style>
